import React, { useState, useEffect } from "react";
import classes from "./SavingsPersonalLedger.module.css";
// import HeaderNav from '../../Components/Dahboard Header/HeaderNav/HeaderNav';
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import {
  BarChart2,
  Filter,
  CalendarClock,
  Mail,
  ArrowLeft,
  Printer,
  Download,
  Settings,
} from "lucide-react";
import Sidebar2 from "../../Components/SideBar2/SideBar2";
import Header2 from "../../Components/Header2/Header2";
import { FaFilePdf, FaFileExcel } from "react-icons/fa";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
// import BackLogo from '../../Assets/assets/back.svg'
// import Footer from "../../Components/Footer/Footer";

const SavingsPersonalLedger = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const {
    ledger,
    //   memberName,
    memberId,
    savingsType,
    totalDebit,
    totalCredit,
    totalBalance,
    totalSavings,
  } = location.state || {};

  // Get customer data from navigation state
  const supplierName = location.state?.memberName || "Member Name"; // Keep as customerName for now since that's what you're passing
  const ledgers = location.state?.member || []; // Keep as customerName for now since that's what you're passing
  const totalBalances = location.state?.totalBalance || []; // Keep as customerName for now since that's what you're passing
  const supplierId = location.state?.customerId || null;
  const supplierDetails = location.state?.customerDetails || null;
  const filteredTransactions = location.state?.filteredInvoices || []; // These are actually supplier ledger entries
  const totalPurchases = location.state?.totalSales || 0; // Total purchases from supplier
  const totalPaid = location.state?.totalPaid || 0;
  const totalOutstanding = location.state?.totalOutstanding || 0;
  const totalInvoices = location.state?.totalInvoices || 0;
  // const ledger = location.state?.ledger || 0;
  const { member } = location.state;
  // console.log("full memebers", member );
  console.log("full ledger", ledgers);

  // Convert invoice data to ledger entries
  const [ledgerData, setLedgerData] = useState([]);

  // Helper functions for currency formatting
  const formatMoney = (value) => {
    const num = Number(value || 0);
    return num.toLocaleString("en-NG", { minimumFractionDigits: 2 });
  };

  const getPaymentStatus = (debtAmount, totalAmount) => {
    const debtNum = parseFloat(debtAmount || 0);
    const totalNum = parseFloat(totalAmount || 0);

    if (debtNum === 0) {
      return "Paid";
    } else if (debtNum === totalNum) {
      return "Owing";
    } else {
      return "Partial";
    }
  };
  // Calculate running balance
  // (For suppliers: debit increases what we owe, credit decreases what we owe)
  let currentRunningTotal = 0;
  const dataWithRunningBalance = ledgers.map((row) => {
    const debitAmount = Number(row.debit || 0);
    const creditAmount = Number(row.credit || 0);
    // const balances = Number(row.balance || 0);

    // Calculate: Previous Balance + current Debit - current Credit
    currentRunningTotal = currentRunningTotal + creditAmount - debitAmount;

    return {
      ...row,
      // Store numeric value for the Closing Balance calculation
      numericRunningBalance: currentRunningTotal,
      // Format for display in the table
      runningBalance: formatMoney(currentRunningTotal),
    };
  });
  // Get the last item to display the final Closing Balance
  const lastRow = dataWithRunningBalance[dataWithRunningBalance.length - 1];

  const totalBalancess = ledgers.reduce(
    (sum, item) => sum + Number(item.balance || 0),
    0,
  );

  const period = (ledgers = []) => {
    if (!ledgers.length) {
      return {
        startDate: "",
        endDate: "",
      };
    }

    const dates = ledgers
      .map((item) => new Date(item.transaction_date))
      .sort((a, b) => a - b);

    const formatDate = (date) =>
      date.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      });

    return {
      startDate: formatDate(dates[0]),
      endDate: formatDate(dates[dates.length - 1]),
    };
  };

  const { startDate, endDate } = period(ledgers);
  const userData = JSON.parse(localStorage.getItem("userData"));
  const memberNumber = localStorage.getItem("memberPhoneNumber");
  const memberAddress = localStorage.getItem("memberAddress");
  const memberName = localStorage.getItem("memberName");
  const compName = localStorage.getItem("companyName");

  // PDF Export - Centered Header
  const handlePdfExport = async () => {
    const table = document.querySelector(`.${classes.table}`);
    if (!table) return;

    try {
      const pdf = new jsPDF({
        orientation: "landscape",
        unit: "mm",
        format: "a4",
      });

      // const pageWidth = pdf.internal.pageSize.getWidth();
      const pageWidth = pdf.internal.pageSize.getWidth();

      let y = 15;

      // Company Name
      pdf.setFont("helvetica", "bold");
      pdf.setFontSize(18);
      pdf.text(compName || "Company Name", pageWidth / 2, y, {
        align: "center",
      });

      y += 8;

      // Report Title
      pdf.setFont("helvetica", "normal");
      pdf.setFontSize(14);
      pdf.text(
        `Members' Saving Ledger - ${new Date().toLocaleDateString()}`,
        pageWidth / 2,
        y,
        {
          align: "center",
        },
      );

      y += 10;

      pdf.line(15, y, pageWidth - 15, y);

      y += 8;

      // Member Information

      pdf.setFontSize(11);

      pdf.setFont("helvetica", "bold");
      pdf.text("Member Name:", 15, y);
      pdf.setFont("helvetica", "normal");
      pdf.text(memberName || "", 45, y);

      pdf.setFont("helvetica", "bold");
      pdf.text("Ledger Period:", 150, y);
      pdf.setFont("helvetica", "normal");
      pdf.text(`${startDate} - ${endDate}`, 182, y);

      y += 7;

      pdf.setFont("helvetica", "bold");
      pdf.text("Address:", 15, y);
      pdf.setFont("helvetica", "normal");
      pdf.text(memberAddress || "", 45, y);

      pdf.setFont("helvetica", "bold");
      pdf.text("Opening Balance:", 150, y);
      pdf.setFont("helvetica", "normal");
      pdf.text("N 0.00", 188, y);

      y += 7;

      pdf.setFont("helvetica", "bold");
      pdf.text("Phone:", 15, y);
      pdf.setFont("helvetica", "normal");
      pdf.text(memberNumber || "", 45, y);

      y += 10;

      // Table
      const canvas = await html2canvas(table, {
        scale: 2,
        useCORS: true,
        backgroundColor: "#ffffff",
      });

      const imgData = canvas.toDataURL("image/png");

      const pageHeight = pdf.internal.pageSize.getHeight();
      const margin = 15;

      const imgWidth = pageWidth - margin * 2;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      let heightLeft = imgHeight;
      let position = y;

      // Draw first page
      pdf.addImage(imgData, "PNG", margin, position, imgWidth, imgHeight);

      heightLeft -= pageHeight - position - margin;

      // Keep track of where the image finishes on the LAST page
      let finalY = pageHeight - margin;

      // Additional pages
      while (heightLeft > 0) {
        pdf.addPage();

        position = margin - (imgHeight - heightLeft);

        pdf.addImage(imgData, "PNG", margin, position, imgWidth, imgHeight);

        // Amount of image visible on this page
        const visibleHeight = Math.min(pageHeight - margin * 2, heightLeft);

        finalY = margin + visibleHeight;

        heightLeft -= pageHeight - margin * 2;
      }

      // If the table ended on the first page
      if (imgHeight <= pageHeight - y - margin) {
        finalY = y + imgHeight;
      }

      // If there's no room for Closing Balance, move it to a new page
      if (finalY + 18 > pageHeight - margin) {
        pdf.addPage();
        finalY = margin;
      }

      pdf.setFont("helvetica", "bold");
      pdf.setFontSize(12);

      pdf.text(
        `Closing Balance: N ${
          lastRow ? formatMoney(lastRow.numericRunningBalance) : "0.00"
        }`,
        pageWidth - 55,
        finalY + 10,
        {
          align: "right",
        },
      );

      pdf.save(
        `Savings_Ledger_${memberName || "Member"}_${
          new Date().toISOString().split("T")[0]
        }.pdf`,
      );
    } catch (err) {
      console.error(err);
      alert("Unable to export PDF.");
    }
  };

  // Excel Export - Centered Header
  const handleExcelExport = () => {
    if (!dataWithRunningBalance.length) {
      alert("No data to export");
      return;
    }

    const ws = XLSX.utils.aoa_to_sheet([]);

    XLSX.utils.sheet_add_aoa(
      ws,
      [
        [compName || "Company Name"],
        [`Members' Saving Ledger - ${new Date().toLocaleDateString()}`],
        [],
        [
          "Member Name",
          memberName || "",
          "Ledger Period",
          `${startDate} - ${endDate}`,
        ],
        ["Address", memberAddress || "", "Opening Balance", "₦0.0"],
        ["Phone", memberNumber || ""],
        [],
        [
          "DATE",
          "REF NO",
          "DESCRIPTION",
          "DEBIT (₦)",
          "CREDIT (₦)",
          "BALANCE (₦)",
        ],
      ],
      {
        origin: "A1",
      },
    );

    const rows = dataWithRunningBalance.map((row) => [
      row.transaction_date,
      row.uuid || "",
      row.description || "",
      Number(row.debit || 0),
      Number(row.credit || 0),
      Number(row.numericRunningBalance || 0),
    ]);

    XLSX.utils.sheet_add_aoa(ws, rows, {
      origin: "A9",
    });

    XLSX.utils.sheet_add_aoa(
      ws,
      [
        [],
        [
          "",
          "",
          "",
          "",
          "Closing Balance",
          lastRow ? Number(lastRow.numericRunningBalance) : 0,
        ],
      ],
      {
        origin: `A${rows.length + 9}`,
      },
    );

    ws["!cols"] = [
      { wch: 15 },
      { wch: 20 },
      { wch: 45 },
      { wch: 18 },
      { wch: 18 },
      { wch: 18 },
    ];

    ws["!merges"] = [
      {
        s: { r: 0, c: 0 },
        e: { r: 0, c: 5 },
      },
      {
        s: { r: 1, c: 0 },
        e: { r: 1, c: 5 },
      },
    ];

    const wb = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(wb, ws, "Savings Ledger");

    const excelBuffer = XLSX.write(wb, {
      bookType: "xlsx",
      type: "array",
    });

    saveAs(
      new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      }),
      `Savings_Ledger_${memberName || "Member"}_${
        new Date().toISOString().split("T")[0]
      }.xlsx`,
    );
  };

  return (
    <div className={classes.container}>
      <Sidebar2
        // active="Member's Savings"
        className={classes.sidebars}
      />
      {/* <HeaderNav className={classes.headers} activePage={pageMap[location.pathname]} /> */}

      <main className={classes.mainContent}>
        <Header2 title="Savings Ledger" className={classes.ledgeHead} />

        <div className={classes.Containers}>
          <div className={classes.backTxt}>
            <div
              className={classes.iconBtn}
              onClick={() => navigate(-1)}
              style={{ cursor: "pointer" }}
            >
              <ArrowLeft size={20} color="#000" strokeWidth={1} />
            </div>
            {/* <MoveLeft className={classes.iconBtn} onClick={() => navigate(-1)} /> */}
            {/* <img src={BackLogo} alt="back" className={classes.iconBtn} onClick={() => navigate(-1)} /> */}
            <div className={classes.bckText}>
              <h3 className={classes.topText}>Member's Saving Ledger </h3>
            </div>
            <div className={classes.iconbarss}>
              {/* Print */}
              <div
                className={classes.iconbar}
                onClick={() => window.print()}
                style={{ cursor: "pointer" }}
              >
                <Printer color="black" size={18} />
              </div>

              {/* PDF Export */}
              <div
                className={classes.iconbar}
                onClick={handlePdfExport}
                style={{ cursor: "pointer" }}
                title="Export to PDF"
              >
                <FaFilePdf size={18} color="#ef4444" />
              </div>

              {/* Excel Export */}
              <div
                className={classes.iconbar}
                onClick={handleExcelExport}
                style={{ cursor: "pointer" }}
                title="Export to Excel"
              >
                <FaFileExcel size={18} color="#10b981" />
              </div>

              {/* Download (optional - you can keep or remove) */}
              {/* <div className={classes.iconbar}>
        <Download color="black" size={18} />
    </div> */}
            </div>
          </div>

          <div className={classes.containere}>
            {/* <div className={classes.divider}></div> */}
            <header className={classes.headers}>
              {/* <h1 className={classes.companyName}>REDEEMED CHRISTIAN CHURCH OF GOD</h1>
                        <h2 className={classes.title}>SUPPLIER'S PERSONAL LEDGER</h2>
                        <p className={classes.period}>For the period ended {new Date().toLocaleDateString()}</p> */}
              <p className={classes.toplea}>{compName}</p>
              <p className={classes.period}>
                Members' Saving Ledger - {""} {new Date().toLocaleDateString()}
              </p>
              {/* <p className={classes.period}>Supplier's Ledger</p> */}
              {/* <button className={classes.unaudited}>unaudited</button> */}
            </header>

            <div className={classes.supplierInformation}>
              <div className={classes.supplierInfo}>
                <h1>
                  Member Name:{" "}
                  <span style={{ fontWeight: 400 }}> {memberName}</span>
                </h1>
                <h1 style={{ marginTop: "0px" }}>
                  Address:{" "}
                  <span style={{ fontWeight: 400 }}> {memberAddress}</span>
                </h1>
                <h1 style={{ marginTop: "0px" }}>
                  Phone:{" "}
                  <span style={{ fontWeight: 400 }}> {memberNumber}</span>
                </h1>
              </div>
              <div className={classes.ledgerInfo}>
                <h1>
                  Ledger Period:{" "}
                  <span style={{ fontWeight: 400 }}>
                    {startDate} - {endDate}
                  </span>
                </h1>
                <h1 style={{ marginTop: "0px" }}>
                  Opening Balance:{" "}
                  <span style={{ fontWeight: 400 }}>
                    {/* {Number(ledgers?.[0]?.balance || 0).toLocaleString(
                "en-NG",
                { minimumFractionDigits: 2, maximumFractionDigits: 2 }
                )} */}
                    ₦0.00
                  </span>
                </h1>
              </div>
            </div>
            {/* Table Container */}
            <div className={classes.tableContainer}>
              <table className={classes.table}>
                <thead>
                  <tr className={classes.tableHeader}>
                    <th>DATE</th>
                    <th>REF NO</th>
                    <th>DESCRIPTION</th>
                    <th style={{ textAlign: "right" }}>DEBIT (₦)</th>
                    <th style={{ textAlign: "right" }}>CREDIT (₦)</th>
                    <th style={{ textAlign: "right" }}>BALANCE (₦)</th>
                  </tr>
                </thead>
                <tbody>
                  {dataWithRunningBalance.length > 0 ? (
                    dataWithRunningBalance.map((row, index) => (
                      <tr key={row.id || index} className={classes.tableRow}>
                        <td className={classes.tableCell}>
                          {row.transaction_date}
                        </td>
                        <td className={classes.tableCell}>{row.uuid}</td>
                        <td className={classes.tableCell}>
                          {row.description || "0"}
                        </td>

                        <td
                          style={{
                            // color: 'rgba(220, 38, 38, 1)',
                            textAlign: "right",
                          }}
                        >
                          {row.debit ? formatMoney(row.debit) : "0.00"}
                        </td>
                        <td
                          style={{
                            // color: 'rgba(22, 163, 74, 1)',
                            textAlign: "right",
                          }}
                        >
                          {row.credit ? formatMoney(row.credit) : "0.00"}
                        </td>
                        <td style={{ textAlign: "right" }}>
                          {/* {row.balance
                                                ? formatMoney(row.balance)
                                                : "0.00"} */}
                          {/* {row.runningBalance
                                                ? formatMoney(row.runningBalance)
                                                : "0.00"} */}
                          {row.runningBalance || "0.00"}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan="6"
                        style={{ textAlign: "center", padding: "20px" }}
                      >
                        No transactions found for {supplierName}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            <div className={classes.closingBalance}>
              <h1 style={{ fontSize: 18 }}>
                Closing Balance: ₦
                {/* {totalBalancess
                                    ? formatMoney(totalBalancess)
                                    : "0.00"} */}
                {lastRow ? formatMoney(lastRow.numericRunningBalance) : "0.00"}
              </h1>
            </div>

            {/* Summary Footer */}

            {/* Footer Table */}
            {/* <table className={classes.footerTable}>
                        <tfoot>
                            <tr>
                                <td className={classes.frston}>First</td>
                                <td className={`${classes.page} ${classes.activePage}`}>1</td>
                                <td className={classes.twono}>2</td>
                                <td className={classes.lastno}>Last</td>
                            </tr>
                        </tfoot>
                    </table> */}

            {/* <div className={classes.lasone}>
                        <div className={classes.paginationDisplay}>
                            Displaying 1 - {dataWithRunningBalance.length} of {dataWithRunningBalance.length}
                        </div>
                    </div> */}
          </div>
        </div>
      </main>
      {/* <Footer className={classes.footers} /> */}
    </div>
  );
};

export default SavingsPersonalLedger;
